export const fields = (t) => {
  const translate = (key, fallback) => {
    if (typeof t !== 'function') return fallback

    const translated = t(key)

    return translated === key ? fallback : translated
  }

  return [
    {
      key: 'delivery_order.number',
      label: translate('delivery.fields.deliveryNumber', 'No. Pengiriman'),
      thClass: 'th-do',
    },
    {
      key: 'activity_type',
      label: translate('delivery.loadsTable.history.activityLabel', 'Aktivitas'),
      thClass: 'th-activity',
    },
    {
      key: 'delivery_order.shipment_number',
      label: translate('delivery.fields.shipmentNumber', 'No. Shipment'),
      formatter: (value) => (value ? value : '-'),
      thClass: 'th-shipment',
    },
    {
      key: 'delivery_order.reference_number',
      label: translate('delivery.fields.referenceNumberText', 'No. Referensi'),
      formatter: (value) => (value ? value : '-'),
      thClass: 'th-reference',
    },
    {
      key: 'delivery_order.customer',
      label: translate('delivery.fields.customerName', 'Pelanggan'),
      thClass: 'head-customer',
    },
    {
      key: 'target_pickup_delivery',
      label: translate('delivery.fields.deliveryTarget', 'Target Diambil/Terkirim'),
      thClass: 'head-target',
    },
    {
      key: 'delivery_order.total_weight',
      label: translate('delivery.loadsTable.fields.weight', 'Berat'),
      thClass: 'th-weight-volume',
    },
    {
      key: 'delivery_order.total_volume',
      label: translate('delivery.fields.volume', 'Volume'),
      thClass: 'th-weight-volume',
    },
  ]
}
